import React from "react";
import HelpText from "./HelpText";
import {HelpTextData} from "../ISR/Pages/DefineModel/model";
import AppSettings from "../../../Settings/AppSettings";
import {useISRContext} from "../ISR/Hooks/useISRContext";

type TFieldProps = {
    selectedItemId?: string | null | undefined
    savedHelpTextData?: HelpTextData | null | undefined
    onDelete: () => void;
    onClose: () => void;
    onSubmit: (helpTextData: HelpTextData) => void;
}

const HelpTextDialog = ({selectedItemId, savedHelpTextData, onDelete, onClose, onSubmit}: TFieldProps) => {
    const isrContext = useISRContext();

    return (
        <div className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[750px] tw-h-auto`}>
                <div className='tw-flex tw-items-center'>
                    <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>{'Help Text'}</h2>
                </div>
                <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />
                <div className={`tw-mx-[4px] tw-pt-4 tw-rounded tw-p-2`}>
                    <HelpText id='list-help-text' savedHelpTextData={savedHelpTextData} selectedItemId={selectedItemId}
                              attachmentUrl={`${AppSettings.GMS_BACKEND_API_URL}/industry/${isrContext?.industryId ?? ''}/list/${selectedItemId}/image/upload`}
                              onDelete={onDelete} onClose={onClose}
                              onSubmit={(helpTextData) => onSubmit(helpTextData)}/>
                </div>
            </div>
        </div>
    );
}

export default HelpTextDialog;